var exports = {
  "kL": "xe533113f--85b8f9--container",
  "vK": "xe533113f--85b8f9--banner",
  "Qq": "xe533113f--85b8f9--text",
};

module.exports = exports;
